import { Directive, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

import {
  AvailabilityStatus,
  IDoctors,
  MedicalDegree,
  AreaOfPractice,
  State,
  TimeSlot,
  CitiesList,
  DaysOfWeek,
  MajorCategories,
  IBodyScanDoctors,
} from '@alpha/types';
import { FormValidators, Calender, ISelectItem, Icon } from 'app-core';

import IconType = Data.Core.IconType;

@Directive()
export class AppointmentScheduleCommon {
  @ViewChild('errorMsg', { static: true })
  public errorMsg!: TemplateRef<any>;
  @ViewChild('holidayErrorMsg', { static: true })
  public holidayErrorMsg!: TemplateRef<any>;
  @ViewChild('workingDayErrorMsg', { static: true })
  public workingDayErrorMsg!: TemplateRef<any>;
  @ViewChild('removeAppointmentErrorMsg', { static: true })
  public removeAppointmentErrorMsg!: TemplateRef<any>;
  @ViewChild('saveRatingErrorMsg', { static: true })
  public saveRatingErrorMsg!: TemplateRef<any>;
  @ViewChild('successMsg', { static: true })
  public successMsg!: TemplateRef<any>;
  @ViewChild('ratingSuccessMsg', { static: true })
  public ratingSuccessMsg!: TemplateRef<any>;
  @ViewChild('successMsgHeader', { static: true })
  public successMsgHeader!: TemplateRef<any>;
  @ViewChild('removeAppointmentMsg', { static: true })
  public removeAppointmentMsg!: TemplateRef<any>;
  @ViewChild('footerMsg', { static: true })
  public footerMsg!: TemplateRef<any>;
  @ViewChild('ratingFooterMsg', { static: true })
  public ratingFooterMsg!: TemplateRef<any>;
  @ViewChild('appointmentFullErrorMsg', { static: true })
  public appointmentFullErrorMsg!: TemplateRef<any>;
  public editMode: boolean = true;
  public showRating: boolean = false;
  public showRemoveAppointmentBtn: boolean = false;
  public item: Partial<IDoctors> | Partial<IBodyScanDoctors> | any = {};
  public icon?: string = '';
  public MedicalDegree = MedicalDegree;
  public AreaOfPractice = AreaOfPractice;
  public City = CitiesList;
  public DaysOfWeek = DaysOfWeek;
  public TimeSlot = TimeSlot;
  public State = State;
  public online: AvailabilityStatus = AvailabilityStatus.Online;
  public timeSlot: Array<ISelectItem> = [];
  public ratings: Array<{ text: number; selected: boolean }> = [];
  public mapIcon: Icon = new Icon({
    icon: IconType.mapIcon,
    hover: true,
    badge: {
      size: 'small',
      color: 'accent',
      content: '',
    },
    tooltip: 'Map',
  });
  public today = new Date();
  public holidaysList: Array<Date> = [];
  public showTimeControl: boolean = false;
  public calender: Calender = new Calender({
    placeholderText: 'Choose a date',
    minDate: new Date(
      this.today.getFullYear(),
      this.today.getMonth(),
      this.today.getDate() + 1,
    ),
    hintText: '(Day/Month/Year)',
    opened: false,
    startAt: new Date(
      this.today.getFullYear(),
      this.today.getMonth(),
      this.today.getDate() + 1,
    ),
  });
  public dateControl: FormControl = new FormControl([
    '',
    FormValidators.dateRangeValidator,
    FormValidators.required,
  ]);
  public timeControl = new FormControl(['', FormValidators.required]);
  public appointmentForm?: FormGroup;
  public readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  public doctorId: string = '';
  public clinicId: string = '';
  public categoryId: MajorCategories = MajorCategories.Doctor;
  public appointmentId: string = '';
  public selectedDate: Date | null = null;

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
